import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface NovaObservacaoDialogData {
  dioId: string;
}

@Component({
    selector: 'app-nova-observacao-dialog',
    templateUrl: './nova-observacao-dialog.component.html',
    styleUrls: ['./nova-observacao-dialog.component.css'],
    standalone: false
})
export class NovaObservacaoDialogComponent {
  observacaoForm: FormGroup;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<NovaObservacaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NovaObservacaoDialogData,
    private fb: FormBuilder
  ) {
    this.observacaoForm = this.fb.group({
      textoObservacao: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.observacaoForm.valid) {
      const observacao = {
        dioId: this.data.dioId,
        textoObservacao: this.observacaoForm.value.textoObservacao
      };
      this.dialogRef.close(observacao);
    }
  }
}
